import { ButtonSelectionType } from '../UIElements/ButtonSelectionType'
import type { IWinPlaceProcessor } from './IWinPlaceProcessor'
import WinPlaceFobProcessor from './WinPlaceFobProcessor'
import WinPlaceToteProcessor from './WinPlaceToteProcessor'

export default class WinPlaceProcessorFactory {
  constructor(private selectionType: ButtonSelectionType) {}

  processor(): IWinPlaceProcessor | null {
    if (this.selectionType === ButtonSelectionType.Tote) {
      return new WinPlaceToteProcessor()
    }

    if (this.selectionType === ButtonSelectionType.Fob) {
      return new WinPlaceFobProcessor()
    }

    return null
  }
}
